import React from 'react'
import { Button, Tooltip } from '@mui/material'

type ValidationButtonProps = {
  showHint: boolean
  hasPendingSelection: boolean
  isChildrenLoading: boolean
  hintMessage: string
  onValidate: () => void
}

const ValidationButton: React.FC<ValidationButtonProps> = ({
  showHint,
  hasPendingSelection,
  isChildrenLoading,
  hintMessage,
  onValidate,
}) => (
  <Tooltip
    title={hintMessage}
    open={showHint}
    disableHoverListener
    arrow
    placement="bottom-start"
    componentsProps={{
      tooltip: {
        sx: {
          '@keyframes hint-bounce': {
            '0%': { transform: 'translateY(0)' },
            '100%': { transform: 'translateY(4px)' },
          },
          'animation': 'hint-bounce 1.2s ease-in-out infinite alternate',
        },
      },
    }}
  >
    <span className="inline-flex ml-6">
      <Button
        variant="contained"
        color={hasPendingSelection ? 'primary' : 'inherit'}
        size="medium"
        disabled={!hasPendingSelection || isChildrenLoading}
        onClick={onValidate}
      >
        Valider
      </Button>
    </span>
  </Tooltip>
)

export { ValidationButton }
